import { render } from "./IndexFive.vue?vue&type=template&id=8294671c"
import script from "./IndexFive.vue?vue&type=script&lang=js"
export * from "./IndexFive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__